import lottie from 'lottie-web';

import type {
  AnimationConfigWithPath,
  AnimationConfigWithData
} from 'lottie-web';

export type AnimationConfig =
  | AnimationConfigWithPath<'canvas' | 'svg'>
  | AnimationConfigWithData<'canvas' | 'svg'>;

export default (data: AnimationConfig) =>
  lottie.loadAnimation({
    renderer: 'svg',
    autoplay: true,
    loop: true,
    ...data
  });
